import PropTypes from "prop-types";

export const mainContainerProps = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
